module.exports = __webpack_public_path__ + "static/media/daas_upgrades.791578f5.png";